
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#currentColor","fill-rule":"evenodd","d":"M13.824 1.512C11.502 2.754 10.8 3.996 10.8 6.642h2.97v4.86H8.802V6.588c0-3.078 1.242-5.238 4.104-6.588l.918 1.512zm-8.802 0C2.7 2.754 1.998 3.996 1.998 6.642h2.97v4.86H0V6.588C0 3.51 1.242 1.35 4.104 0l.918 1.512z"}})])
          )
        }
      }
    